<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-converter drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-converter" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          Converter
        </font>
        <v-spacer></v-spacer>
        <v-btn
          class="btn btn-save rounded-xl mr-2"
          :disabled="!$auth.manage || isDisableSave"
          v-if="!isHistory"
          @click="save"
          >{{ $t('btn.common.save') }}</v-btn
        >
        <v-btn
          class="btn btn-delete rounded-xl mr-2"
          :disabled="!$auth.manage || !formData.cvtrId"
          v-if="!isHistory"
          @click="deleteConverter"
          >{{ $t('btn.common.delete') }}</v-btn
        >
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="12" class="px-3 py-0">
          <div class="d-flex justify-space-between align-center">
            <v-label class="pt-2">Name</v-label>
            <div class="right-text">
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="copyData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-copy"
                />
              </v-btn>
              <v-btn
                style="visibility: hidden;height:22px;"
                :disabled="isHistory"
                class="px-0"
                @click="clearData"
              >
                <icon-svg
                  style="visibility: visible;"
                  width="60"
                  height="22"
                  iconName="comp-clear"
                />
              </v-btn>
            </div>
          </div>
          <v-combobox
            v-model="comId"
            :items="converterList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="cvtrId"
            item-text="cvtrNm"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-combobox>
        </v-col>
        <v-col
          v-for="(converter, index) in listConverter"
          :key="index"
          cols="12"
          md="12"
          class="px-3"
        >
          <div class="d-flex justify-between align-center mb-1">
            <v-label>
              <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
              {{ $t('lbl.converters.page_header') }} # {{ index + 1 }}
            </v-label>
            <div class="d-flex">
              <span style="cursor: pointer;" @click="handleAddConverter(index)">
                <icon-svg iconName="add-conv" />
              </span>
              <span style="cursor: pointer;" @click="handleRemoveConverter(index)">
                <icon-svg
                  v-if="index > 0 || listConverter.length > 1"
                  class="ml-1"
                  iconName="remove-conv"
                />
              </span>
            </div>
          </div>
          <v-row class="px-2 ma-0" style="border: 1px solid #C5D1E3; border-radius: 4px;">
            <v-col cols="12" md="12" class="px-4 py-0 mt-4">
              <v-select
                v-model="converter.cvtrTpCd"
                :items="cvtrTpCdList"
                :rules="[validationUtils.required]"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                @change="
                  selectConverterType(index);
                  checkChangeConverter(index);
                "
              ></v-select>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                  converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                  converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                  converter.cvtrTpCd === 'API_CAPTOR' ||
                  converter.cvtrTpCd === 'FILENAME_REPLACER' ||
                  converter.cvtrTpCd === 'SHINE_CAPTOR'
              "
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>
                <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ converter.cvtrTpCd === 'API_CAPTOR' ? 'API URI' : 'Search pattern' }}
              </v-label>
              <v-text-field
                v-model="converter.srcPttn"
                ref="srcPttn"
                :disabled="!$auth.manage"
                :rules="[validationUtils.required]"
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'FILENAME_REPLACER' ||
                  converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                  converter.cvtrTpCd === 'SHINE_CAPTOR'
              "
              cols="12"
              md="12"
              class="px-3 py-0 flex justify-between"
            >
              <v-label>
                <v-icon x-small class="mr-1" v-show="converter.cvtrTpCd !== 'FILECONTENT_REPLACER'"
                  >fa fa-asterisk</v-icon
                >
                {{ $t('lbl.converters.replacePttn') }}
              </v-label>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'FILENAME_REPLACER' ||
                  converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                  converter.cvtrTpCd === 'SHINE_CAPTOR'
              "
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-text-field
                v-model="converter.repPttn"
                :disabled="!$auth.manage"
                v-bind="
                  converter.cvtrTpCd !== 'FILECONTENT_REPLACER'
                    ? { rules: [validationUtils.required] }
                    : {}
                "
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col
              v-show="converter.cvtrTpCd === 'FILENAME_REDUCER'"
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>
                <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ $t('lbl.converters.maxFileName') }}
              </v-label>
              <v-text-field
                v-model="converter.nmMaxLen"
                :disabled="!$auth.manage"
                :rules="[validationUtils.required]"
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col
              v-show="converter.cvtrTpCd === 'FILENAME_REDUCER'"
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>
                <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ $t('lbl.converters.cutFileName') }}
              </v-label>
              <v-select
                v-model="converter.nmCutTp"
                :items="cutTypeList"
                :rules="[validationUtils.required]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
                :menu-props="{ offsetY: true }"
                @change="checkChangeConverter(index)"
              ></v-select>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                  converter.cvtrTpCd === 'FILECONTENT_CAPTOR'
              "
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>
                {{ $t('lbl.converters.numSkip') }}
              </v-label>
              <v-text-field
                v-model="converter.skipLineCnt"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'FILECONTENT_REPLACER' ||
                  converter.cvtrTpCd === 'FILECONTENT_CAPTOR'
              "
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>
                {{ $t('lbl.converters.numRepeat') }}
              </v-label>
              <v-text-field
                v-model="converter.reptLineCnt"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'FILE_ENVELOPER' || converter.cvtrTpCd === 'FILE_DEENVELOPER'
              "
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>
                {{
                  converter.cvtrTpCd === 'FILE_ENVELOPER' ? 'Envelope header' : 'Deenvelope header'
                }}
              </v-label>
              <v-text-field
                v-model="converter.envHdr"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'FILE_ENVELOPER' || converter.cvtrTpCd === 'FILE_DEENVELOPER'
              "
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>{{
                converter.cvtrTpCd === 'FILE_ENVELOPER' ? 'Envelope footer' : 'Deenvelope footer'
              }}</v-label>
              <v-text-field
                v-model="converter.envFtr"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col
              v-show="converter.cvtrTpCd === 'FILE_DEENVELOPER'"
              cols="12"
              md="12"
              class="px-3 py-0"
            >
              <v-label>{{ $t('lbl.converters.splitPttn') }}</v-label>
              <v-text-field
                v-model="converter.spltPttn"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                solo
                @keyup="checkChangeConverter(index)"
              ></v-text-field>
            </v-col>
            <v-col v-show="converter.cvtrTpCd === 'DB_CAPTOR'" cols="10" md="10" class="px-3 py-0">
              <v-label>
                <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ $t('lbl.converters.dbBroker') }}
              </v-label>
              <v-autocomplete
                v-model="converter.dBBroker"
                :rules="[validationUtils.required]"
                :items="dbBrkList"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                solo
                @change="checkChangeConverter(index)"
              ></v-autocomplete>
            </v-col>
            <v-col
              v-show="converter.cvtrTpCd === 'DB_CAPTOR'"
              cols="2"
              md="2"
              class="pl-0 py-7 pr-0"
            >
              <v-btn
                class="btn-search"
                :style="$vuetify.theme.dark ? 'background-color: #3b3e49' : ''"
                :disabled="$cookies.get('comp-id') !== $cookies.get('ownr-id')"
                @click.native="openDialogVisible(converter.dBBroker)"
              >
                <v-icon x-small>fa fa-search</v-icon>
              </v-btn>
            </v-col>

            <v-col
              v-show="
                converter.cvtrTpCd === 'USERDATA_CAPTOR' ||
                  converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                  converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                  converter.cvtrTpCd === 'API_CAPTOR' ||
                  converter.cvtrTpCd === 'DB_CAPTOR'
              "
              cols="12"
              md="5"
              class="pl-3 pr-0 py-0 mb-4"
            >
              <v-label
                v-if="converter.cvtrTpCd !== 'API_CAPTOR' && converter.cvtrTpCd !== 'DB_CAPTOR'"
              >
                <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                {{ $t('lbl.processSetup.converter_data_user') }}
              </v-label>
              <v-label v-else>{{ $t('lbl.processSetup.converter_data_user') }}</v-label>
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'USERDATA_CAPTOR' ||
                  converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                  converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                  converter.cvtrTpCd === 'API_CAPTOR' ||
                  converter.cvtrTpCd === 'DB_CAPTOR'
              "
              cols="12"
              md="7"
              class=" pl-0 py-0 text-left"
            >
              <v-icon
                @click="addCaptor(index)"
                :disabled="!$auth.manage"
                :readonly="isHistory"
                dense
                dark
                >mdi-plus</v-icon
              >
            </v-col>
            <v-col
              v-show="
                converter.cvtrTpCd === 'USERDATA_CAPTOR' ||
                  converter.cvtrTpCd === 'FILENAME_CAPTOR' ||
                  converter.cvtrTpCd === 'FILECONTENT_CAPTOR' ||
                  converter.cvtrTpCd === 'API_CAPTOR' ||
                  converter.cvtrTpCd === 'DB_CAPTOR'
              "
              cols="12"
              md="12"
              class="px-3 pb-4 pt-0"
            >
              <v-row
                class="pt-0 pt-0 pb-1 edi-identification-right"
                v-for="(item, i) in converter.listUserData"
                :key="item.id"
              >
                <v-col lg="4" class="pl-3 pr-2 py-0">
                  <v-text-field
                    :ref="'CAPTOR_' + index + '_' + item.id"
                    :maxlength="50"
                    solo
                    hide-details
                    placeholder="Key"
                    :disabled="!$auth.manage"
                    :readonly="isHistory"
                    v-model="item.key"
                    @keyup="checkChangeConverter(index)"
                  ></v-text-field>
                </v-col>
                <v-col lg="7" class="pl-2 pr-2 py-0">
                  <v-text-field
                    :ref="'CAPTOR_' + index + '_' + item.id + '_' + item.id"
                    :maxlength="50"
                    solo
                    hide-details
                    placeholder="Value"
                    :disabled="!$auth.manage"
                    :readonly="isHistory"
                    v-model="item.value"
                    @keyup="checkChangeConverter(index)"
                  ></v-text-field>
                </v-col>
                <v-col lg="1" class="pa-0 pr-3 mr-0 mt-2">
                  <v-icon
                    @click="removeCaptor(index, i)"
                    :disabled="!$auth.manage"
                    :readonly="isHistory"
                    dense
                    class="ml-1"
                    dark
                    >mdi-minus</v-icon
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="AlertConverterSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertConverterSetup.dialog = false"
    >
    </dialogWindow>
    <dialogWindow
      ref="RegisteredSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Converter', 'created'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Converter', 'modified'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="deleteCvtr"
      title="Delete Converter"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['converter'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Merge & Compare"
      :detail="add_valid_str"
      color="warning"
    ></dialogWindow>
    <dialogWindow
      ref="errorDialog"
      size="max"
      title="Merge & Compare"
      :detail="add_valid_str"
      color="error"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import cfg from '@/vue-caas/config/config.js';
import { getEditData } from '@/vue-caas/utils/process';
import { runSave } from '@/vue-caas/views/processnew/component/saveRunner.js';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
    manageDBB: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'FLT',
      listConverter: [
        {
          cvtrId: '',
          seq: 0,
          cvtrTpCd: 'FILENAME_REPLACER',
          srcPttn: '',
          repPttn: '',
          nmMaxLen: '',
          nmCutTp: '',
          skipLineCnt: '',
          reptLineCnt: '',
          envHdr: '',
          envFtr: '',
          spltPttn: '',
          dBBroker: '',
          listUserData: [],
          flag: 'I',
        },
      ],
      formData: {
        byProcSetup: true,
        cvtrId: '',
        cvtrNm: '',
      },
      loadFormData: {
        byProcSetup: true,
        cvtrId: '',
        cvtrNm: '',
      },
      add_valid_str: '',
      cvtrTpCdList: [],
      checkDialogInfo: '',
      checkDialogColor: 'warning',
      dbBrkList: [],
      isDisableSave: false,
      deleteSubList: [],
      isChanged: false,
      cutTypeList: [
        { value: '0', text: 'Cut From Left' },
        { value: '1', text: 'Cut From Right (with out extension)' },
        { value: '2', text: 'Cut From Rigth (with extension)' },
      ],
    };
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
    EventBus.$on('updateFormData', this.updateFormData);
  },
  methods: {
    openDialogVisible(dbBrokerId) {
      EventBus.$emit('openDBCaptorDetail', { dbBrokerId: dbBrokerId });
    },
    checkChangeConverter(index) {
      let converter = this.listConverter[index];
      if (converter.cvtrId) {
        converter.flag = 'U';
        this.isChanged = true;
        this.listConverter.splice(index, 1, converter);
      }
    },
    copyData() {
      this.formData.cvtrId = '';
      this.formData.cvtrNm = '';
      this.comId = '';
      this.listConverter.forEach((e) => {
        e.oldSeq = '';
        e.flag = 'I';
        e.cvtrId = '';
      });
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    clearData() {
      this.formData.cvtrNm = '';
      this.formData.cvtrId = '';
      this.changeConverter('');
      this.comId = '';
    },
    changeComponentData() {
      if (this.comId && this.comId.value) {
        this.changeConverter(this.comId.value);
      } else {
        if (this.formData.cvtrId) {
          this.changeConverter('');
        }
        this.formData.cvtrNm = this.comId;
      }
      this.checkCvtrName();
    },
    resetForm() {
      this.formData = {
        byProcSetup: true,
        cvtrId: '',
        cvtrNm: '',
      };
      this.listConverter = [
        {
          cvtrId: '',
          seq: 0,
          cvtrTpCd: 'FILENAME_REPLACER',
          srcPttn: '',
          repPttn: '',
          repPttnInput: '',
          nmMaxLen: '',
          nmCutTp: '',
          skipLineCnt: '',
          reptLineCnt: '',
          envHdr: '',
          envFtr: '',
          spltPttn: '',
          dBBroker: '',
          listUserData: [],
          flag: 'I',
        },
      ];
      this.deleteSubList = [];
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    updateFormData(data) {
      if (this.nodeId === data.nodeInfo) this.resetForm();
      return;
    },
    addCaptor(index) {
      const converter = this.listConverter[index];
      let i =
        converter.listUserData.length > 0
          ? converter.listUserData[converter.listUserData.length - 1].id + 1
          : 1;
      let obj = {
        id: i,
        key: '',
        value: '',
      };
      converter.listUserData.push(obj);
      this.listConverter.splice(index, 1, converter);
      this.isChanged = true;
    },
    removeCaptor(index, i) {
      const converter = this.listConverter[index];
      converter.flag = 'U';
      converter.listUserData.splice(i, 1);
      this.listConverter.splice(index, 1, converter);
      this.isChanged = true;
    },
    checkCvtrName() {
      this.converterList.map((e) => {
        if (e.text === this.formData.cvtrNm && e.cvtrId !== this.formData.cvtrId) {
          this.formData.cvtrNm = '';
          this.comId = '';
          this.checkDialogInfo = `Converter name : ${e.text} have been created !`;
          this.checkDialogColor = 'warning';
          this.$refs.AlertConverterSetup.dialog = true;
          return;
        }
      });
    },
    selectConverterType(index) {
      const type = this.listConverter[index].cvtrTpCd;
      const id = this.listConverter[index].cvtrId;
      const seq = this.listConverter[index].seq;
      const flag = this.listConverter[index].flag;
      let converter = Object.assign({}, this.getInitData());
      converter.cvtrTpCd = type;
      converter.cvtrId = id;
      converter.seq = seq;
      converter.flag = flag;
      if (type == 'FILENAME_REPLACER' || type == 'SHINE_CAPTOR') {
        converter.srcPttn = String.raw`.+`;
      } else {
        converter.srcPttn = '';
      }
      if (type == 'FILENAME_REDUCER') {
        converter.nmCutTp = '0';
      } else {
        converter.nmCutTp = '';
      }
      this.listConverter.splice(index, 1, converter);
    },
    getInitData() {
      return {
        cvtrTpCd: '',
        cvtrId: '',
        seq: '',
        srcPttn: '',
        repPttn: '',
        nmMaxLen: '',
        nmCutTp: '',
        skipLineCnt: '',
        reptLineCnt: '',
        envHdr: '',
        envFtr: '',
        spltPttn: '',
        dBBroker: '',
        listUserData: [],
      };
    },
    initialize() {
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.cvtrTpCdList = this.options.item.data.cvtrTpCdList;
      this.dbBrkList = this.dbBrokerSelectBoxList;
      if (!this.manageDBB && !this.isHistory) {
        this.cvtrTpCdList = this.options.item.data.cvtrTpCdList.filter(
          (e) => e.value !== 'DB_CAPTOR',
        );
        this.dbBrkList = [];
      }

      this.changeConverter(this.options.item.data.comId);
    },
    changeConverter(id) {
      this.deleteSubList = [];
      if (this.$refs.form) this.$refs.form.resetValidation();
      let index = this.converterList.findIndex((e) => e.cvtrId == id);
      if (
        index > -1 &&
        (this.manage || this.isHistory) &&
        // reset if NOT have permission to manage DB Broker but converterList have item with type DB_CAPTOR
        (!(
          this.converterList[index].subList.some((e) => e.cvtrTpCd === 'DB_CAPTOR') &&
          !this.manageDBB
        ) ||
          this.isHistory)
      ) {
        let listData = this.converterList[index].subList;
        for (let i = 0; i < listData.length; i++) {
          listData[i].listUserData = [];
          if (listData[i].repPttn !== '' && listData[i].cvtrTpCd.includes('CAPTOR')) {
            let arrPttn = listData[i].repPttn.replace(/"/g, '').split(',');
            listData[i].listUserData = [];
            for (let j = 0; j < arrPttn.length; j += 2) {
              listData[i].listUserData.push({
                id: j / 2,
                key: arrPttn[j],
                value: arrPttn[j + 1],
              });
            }
          }
          if (listData[i].cvtrTpCd === 'DB_CAPTOR') {
            const dupIndex = this.dbBrkList.findIndex((e) => e.value === listData[i].srcPttn);
            if (dupIndex > -1) {
              listData[i].dBBroker = listData[i].srcPttn;
            } else {
              listData[i].dBBroker = '';
            }
          }
        }
        this.listConverter = listData;
        this.formData = Object.assign({}, this.converterList[index]);
        this.loadFormData = Object.assign({}, this.converterList[index]);

        this.formData.byProcSetup = true;
        this.loadFormData.byProcSetup = true;
        this.comId = Object.assign({}, this.converterList[index]);
        if (this.formData.cvtrId === '1') {
          this.isDisableSave = true;
        } else {
          this.isDisableSave = false;
        }
        EventBus.$emit('change-component-data', id, this.nodeId);
      } else {
        this.resetForm();
      }
    },
    closeComDialog() {
      this.checkDataChange();
    },

    async save() {
      await runSave(this, 'CVT', { mode: 'form', data: this.formData });
    },
    actionDel() {
      let self = this;
      this.$store.dispatch('deleteConverter', { cvtrId: this.formData.cvtrId }).then(() => {
        this.$store.dispatch('getCvtrGrpList').then((res) => {
          this.$refs.form.resetValidation();
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'CVT') {
              if (comp.formData.cvtrId === self.formData.cvtrId) {
                comp.resetForm();
              }
            }
          });
          this.comId = '';
          this.changeConverter('');
        });
      });
    },
    deleteConverter() {
      if (cfg.isDlb) {
        this.$refs.deleteCvtr.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', {
            type: 'CVT',
            value: this.formData.cvtrId,
          })
          .then((res) => {
            if (res.length > 0) {
              EventBus.$emit('openDelHistoryWorkflowDialog', res, this.formData, this.nodeId);
            } else {
              this.$refs.deleteCvtr.dialog = true;
            }
          });
      }
    },
    checkDataChange() {
      this.formData.byProcSetup = true;
      let editedData = getEditData(this.formData, this.loadFormData);
      if (Object.keys(editedData).length !== 0 || this.isChanged === true) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    handleAddConverter(index) {
      for (let i = 0; i < this.listConverter.length; i++) {
        let converter = this.listConverter[i];
        if (converter.seq > index) {
          converter.oldSeq = converter.oldSeq ? converter.oldSeq : converter.seq;
          converter.seq += 1;
          if (converter.cvtrId) converter.flag = 'U';
          this.listConverter.splice(i, 1, converter);
        }
      }
      const converter = {
        cvtrTpCd: 'FILENAME_REPLACER',
        seq: index + 1,
        srcPttn: '',
        repPttn: '',
        nmMaxLen: '',
        nmCutTp: '',
        skipLineCnt: '',
        reptLineCnt: '',
        envHdr: '',
        envFtr: '',
        spltPttn: '',
        flag: 'I',
      };
      this.listConverter.splice(index + 1, 0, converter);
      this.isChanged = true;
    },
    handleRemoveConverter(index) {
      for (let i = 0; i < this.listConverter.length; i++) {
        let converter = this.listConverter[i];
        if (converter.seq > index) {
          converter.oldSeq = converter.oldSeq ? converter.oldSeq : converter.seq;
          converter.seq -= 1;
          if (converter.cvtrId) converter.flag = 'U';
          this.listConverter.splice(i, 1, converter);
        }
      }
      if (this.listConverter[index].cvtrId) this.deleteSubList.push(this.listConverter[index]);
      this.listConverter.splice(index, 1);
      this.isChanged = true;
    },
  },
  computed: {
    converterList() {
      return this.$store.getters.converterSelectBoxList;
    },
    dbBrokerSelectBoxList() {
      return this.$store.getters.dbBrokerSelectBoxList;
    },
  },
};
</script>

<style></style>
